class Competitor {
  id?: number;
  name: string = "";
  private: boolean = true;
}

export default Competitor;
